export const rootSettings = {
  site: 'Yok Radio',
  author: 'Yok Radio',
  ogType: 'website',
  title: 'Yok Radio - Últimas noticias en español de música y Podcast en español',
  description: 'Somos la radio online para todos los gustos, contamos con 5 estaciones, playlist, especiales, podcast, las últimas noticias musicales y mucho más.',
  keywords: 'Yok, Podcast en Español, News, Noticias en Español, Webshows en Español, Programas en Español, Streaming en vivo, Contenido de Entretenimiento, Noticias de cines y series, noticias de Cine, noticias de series, noticias geek, mundo geek, only geeks, Fotos de Modelos, Fotografía de Modelaje, producciones audiovisuales, podcast, webshows',
  image: 'https://yokradio.com/assets/images/preview_card_v4.jpg',
  image_width: '1024',
  image_height: '1024'
}

export const newsSettings = {
  ogType: 'website',
  title: 'Yok Radio - Últimas noticias de música en español.',
  description: 'Lee las últimas noticias en español de música que están en tendencia.',
  keywords: 'Yok, Podcast en Español, News, Noticias en Español, Webshows en Español, Programas en Español, Streaming en vivo, Contenido de Entretenimiento, Noticias de cines y series, noticias de Cine, noticias de series, noticias geek, mundo geek, only geeks, Fotos de Modelos, Fotografía de Modelaje, producciones audiovisuales, podcast, webshows',
  image: 'https://yokradio.com/assets/images/preview_card_v4.jpg',
  image_width: '1024',
  image_height: '1024',
  section: {
    alias: 'news',
    id: '3'
  },
  navigation: {
    rows: 12
  }
}

export const radioSettings = {
  ogType: 'website',
  title: 'Podcast en español y Shows Musicales - Yok Radio',
  description: 'Disfruta de los mejores tops, playlist, especiales musicales, podcast español producidos por Yok Radio.',
  keywords: 'Yok, Podcast en Español, News, Noticias en Español, Webshows en Español, Programas en Español, Streaming en vivo, Contenido de Entretenimiento, Noticias de cines y series, noticias de Cine, noticias de series, noticias geek, mundo geek, only geeks, Fotos de Modelos, Fotografía de Modelaje, producciones audiovisuales, podcast, webshows',
  image: 'https://yokradio.com/assets/images/preview_card_v4.jpg',
  image_width: '1024',
  image_height: '1024',
  section: {
    alias: 'radio',
    id: '4'
  },
  navigation: {
    rows: 12
  }
}

export const topSettings = {
  ogType: 'website',
  title: 'Tops de música - Yok Radio ',
  description: 'Disfruta de tops musicales con canciones seleccionadas y mezcladas en Yok Radio',
  keywords: 'Yok, Podcast en Español, News, Noticias en Español, Webshows en Español, Programas en Español, Streaming en vivo, Contenido de Entretenimiento, Noticias de cines y series, noticias de Cine, noticias de series, noticias geek, mundo geek, only geeks, Fotos de Modelos, Fotografía de Modelaje, producciones audiovisuales, podcast, webshows, radio, tops, mezclas, tops musicales, mezclas musicales',
  image: 'https://yokradio.com/assets/images/preview_card_v4.jpg',
  image_width: '1024',
  image_height: '1024',
  section: {
    alias: 'tops'
  },
  navigation: {
    rows: 12
  }
}

export const searchSettings = {
  limit: 20
}
